import { createSelector } from 'reselect';
import { UIReducerStateProps } from './types';

/**
 * Selects the permissions state slice.
 * @type {Selector<*, UIStateSlice>}
 */
export const uiSelector = (state: UIReducerStateProps) => state.ui;

export const notificationsSelector = createSelector(
  uiSelector,
  ({ notifications }) => notifications
);

export const pendingRequestsSelector = createSelector(
  uiSelector,
  ({ pendingRequests }) => pendingRequests
);

export const openedModalSelector = createSelector(
  uiSelector,
  ({ openedModal }) => openedModal
);

export const getFormValue = createSelector(
  uiSelector,
  ({ form }) => form
);

export const getCurrentSelectedTabValue = createSelector(
  uiSelector,
  ({ currentSelectedTab }) => currentSelectedTab
);
